import actions from '../../../../sharedmodules/actions-list';

export const resetUserDealerData = () => ({
    type: actions.RESET_DEALER_PIN_TRANSFER_DATA,
});
